// Refactoring Done 2023

import ActivityCategory from "./data/activitiy-category";


const SystemEnvironment = {
  production: {
    // abu dhabi
    // Propx@xeleration.net
    name: "production",
    AI_environment:'AbuDahbi',
    server_address: 'https://apigateway.replica.psi-crm.com',
    ws_address: 'wss://apigateway.replica.psi-crm.com',
    server_name: 'apigateway.replica.psi-crm.com',
    leadxchange_server_address: 'https://apigateway.replica.psi-crm.com',
    ActivityTypesCategoryId: 63385,
    MultiUnitsTemplateId: 1252,
    hotjarSiteId: 3891241,

    RejectWithCounterProposal: 1829,
    PriceNegotiationApproved: 1827,
    PriceNegotiationRejected: 1828,
    RequestSendingOfferLetter: 1825,
    PriceNegotiation: 1826,

    ContactDocsCategoryIds_EID : 63383,
    ContactDocsCategoryIds_KYC : 63384,
    WhatsAppConsentTemplate : 1422,
    HoldingCompany : 71849,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1283,
      ResidentialOfferLetter: 1281,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1287,
      ResidentialOfferLetter: 1288,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1420,
      ResidentialTenancyContract: 1421,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1418,
      ResidentialTenancyContract: 1419,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
  },
  international: {
    // abu dhabi
    // Propx@xeleration.net
    name: "international",
    AI_environment:'international',
    server_address: 'https://apigateway.international-crm.com',
    ws_address: 'wss://apigateway.international-crm.com',
    leadxchange_server_address: 'https://apigateway.replica.psi-crm.com',
    server_name: 'apigateway.international-crm.com',
    ActivityTypesCategoryId: 63385,
    MultiUnitsTemplateId: 1252,
    hotjarSiteId: 3891241,

    RejectWithCounterProposal: 1829,
    PriceNegotiationApproved: 1827,
    PriceNegotiationRejected: 1828,
    RequestSendingOfferLetter: 1825,
    PriceNegotiation: 1826,
    HoldingCompany : 71849,
    ContactDocsCategoryIds_EID : 63383,
    ContactDocsCategoryIds_KYC : 63384,
    WhatsAppConsentTemplate : 1422,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1283,
      ResidentialOfferLetter: 1281,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1287,
      ResidentialOfferLetter: 1288,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1420,
      ResidentialTenancyContract: 1421,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1418,
      ResidentialTenancyContract: 1419,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
  },
    data: {
    // abu dhabi
    // Propx@xeleration.net
    name: "data",
    AI_environment:'data',
    server_address: 'https://apigateway.psidata-crm.com',
    ws_address: 'wss://apigateway.psidata-crm.com',
    server_name: 'apigateway.psidata-crm.com',
    leadxchange_server_address: 'https://apigateway.replica.psi-crm.com',
    ActivityTypesCategoryId: 63385,
    MultiUnitsTemplateId: 1252,
    hotjarSiteId: 3891241,

    RejectWithCounterProposal: 1829,
    PriceNegotiationApproved: 1827,
    PriceNegotiationRejected: 1828,
    RequestSendingOfferLetter: 1825,
    PriceNegotiation: 1826,
    HoldingCompany : 71849,
    ContactDocsCategoryIds_EID : 63383,
    ContactDocsCategoryIds_KYC : 63384,
    WhatsAppConsentTemplate : 1422,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1283,
      ResidentialOfferLetter: 1281,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1287,
      ResidentialOfferLetter: 1288,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1420,
      ResidentialTenancyContract: 1421,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1418,
      ResidentialTenancyContract: 1419,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
  },
    egypt: {
    // abu dhabi
    // Propx@xeleration.net
    name: "egypt",
    AI_environment:'egypt',
    server_address: 'https://apigateway.egypt-crm.com',
    ws_address: 'wss://apigateway.egypt-crm.com',
    server_name: 'apigateway.egypt-crm.com',
    leadxchange_server_address: 'https://apigateway.replica.psi-crm.com',
    ActivityTypesCategoryId: 63385,
    MultiUnitsTemplateId: 1252,
    hotjarSiteId: 3891241,

    RejectWithCounterProposal: 1829,
    PriceNegotiationApproved: 1827,
    PriceNegotiationRejected: 1828,
    RequestSendingOfferLetter: 1825,
    PriceNegotiation: 1826,
    HoldingCompany : 71849,
    ContactDocsCategoryIds_EID : 63383,
    ContactDocsCategoryIds_KYC : 63384,
    WhatsAppConsentTemplate : 1422,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1283,
      ResidentialOfferLetter: 1281,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1287,
      ResidentialOfferLetter: 1288,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1420,
      ResidentialTenancyContract: 1421,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1418,
      ResidentialTenancyContract: 1419,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
  },
  development: {
    name: "development",
    server_address: 'https://apigateway.dev.replica.psi-crm.com',
    ws_address: 'wss://apigateway.dev.replica.psi-crm.com',
    server_name: 'apigateway.dev.replica.psi-crm.com',
    leadxchange_server_address: 'https://apigateway.dev.replica.psi-crm.com',
    DisableRightClicking: false,
    ThemeBi: true,
    AI_environment:'Dev',
    ActivityTypesCategoryId: 63385,
    MultiUnitsTemplateId: 1252,
    hotjarSiteId: 3891241,
    RejectWithCounterProposal: 1827,
    PriceNegotiationApproved: 1825,
    PriceNegotiationRejected: 1826,
    RequestSendingOfferLetter: 1823,
    PriceNegotiation: 1824,
    ContactDocsCategoryIds_EID : 63383,
    ContactDocsCategoryIds_KYC : 63384,
    WhatsAppConsentTemplate : 1422,
    HoldingCompany : 71849,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1283,
      ResidentialOfferLetter: 1281,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1287,
      ResidentialOfferLetter: 1288,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1420,
      ResidentialTenancyContract: 1421,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1418,
      ResidentialTenancyContract: 1419,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
    apiKey: 'Ag8KhsUUYJKl1xkls92zkadsS87299akd881s2kso02XXZaaasa',
  },
  qa: {
    name: "qa",
    server_address: 'https://apigateway.qa.replica.psi-crm.com',
    ws_address: 'wss://apigateway.qa.replica.psi-crm.com',
    server_name: 'apigateway.qa.replica.psi-crm.com',
    leadxchange_server_address: 'https://apigateway.dev.replica.psi-crm.com',
    DisableRightClicking: false,
    ThemeBi: true,
    AI_environment:'QA',
    MultiUnitsTemplateId: 1252,
    RejectWithCounterProposal: 1827,
    PriceNegotiationApproved: 1825,
    PriceNegotiationRejected: 1826,
    RequestSendingOfferLetter: 1823,
    PriceNegotiation: 1824,
    ActivityTypesCategoryId: 63385,
    hotjarSiteId: 3891241,
    ContactDocsCategoryIds_EID : 63383,
    ContactDocsCategoryIds_KYC : 63384,
    WhatsAppConsentTemplate : 1422,
    HoldingCompany : 71849,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1283,
      ResidentialOfferLetter: 1281,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1287,
      ResidentialOfferLetter: 1288,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1420,
      ResidentialTenancyContract: 1421,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1418,
      ResidentialTenancyContract: 1419,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
    apiKey: 'FsqMtUmxSJexe10vXF9sC4zhuax3bCZ6GFdwFYpbjKGRCVjvbtsKfXOWfKglVTx7zzzz',
  },
  dubaiCRMConfig: {
    name: "dubaiCRMConfig",
    // production for dubai
    // info@xeleration.net
    AI_environment:'Dubai',
    server_address: 'https://apigateway.dubai-crm.com',
    ws_address: 'wss://apigateway.dubai-crm.com',
    server_name: 'apigateway.dubai-crm.com',
    leadxchange_server_address: 'https://apigateway.replica.psi-crm.com',
    MultiUnitsTemplateId: 1222,
    hotjarSiteId: 3909956,
    ContactDocsCategoryIds_EID : 62357,
    RejectWithCounterProposal: 5107,
    PriceNegotiationApproved: 5105,
    PriceNegotiationRejected: 5106,
    RequestSendingOfferLetter: 5103,
    PriceNegotiation: 5104,
    ContactDocsCategoryIds_KYC : 62358,
    WhatsAppConsentTemplate : 1341,
    HoldingCompany : 71849,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1227,
      ResidentialOfferLetter: 1226,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1229,
      ResidentialOfferLetter: 1230,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1337,
      ResidentialTenancyContract: 1338,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1335,
      ResidentialTenancyContract: 1336,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
  },
  dubai: {
    name: "dubai",
    server_address: 'https://apigateway.dubai.replica.psi-crm.com',
    ws_address: 'wss://apigateway.dubai.replica.psi-crm.com',
    server_name: 'apigateway.dubai.replica.psi-crm.com',
    GetMyFormsReportsTypeReportsBuilder: 3189,
    leadxchange_server_address: 'https://apigateway.replica.psi-crm.com',
  },
  staging: {
    name: "staging",
    server_address: 'https://apigateway.stg.replica.psi-crm.com',
    ws_address: 'wss://apigateway.stg.replica.psi-crm.com',
    freshdesk_ws_id: 73000000915,
    server_name: 'apigateway.stg.replica.psi-crm.com',
    leadxchange_server_address: 'https://apigateway.dev.replica.psi-crm.com',
    MultiUnitsTemplateId: 1250,
    RejectWithCounterProposal: 1829,
    PriceNegotiationApproved: 1827,
    PriceNegotiationRejected: 1828,
    RequestSendingOfferLetter: 1825,
    PriceNegotiation: 1826,
    WhatsAppConsentTemplate : 1274,
    HoldingCompany : 71849,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1283,
      ResidentialOfferLetter: 1281,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1287,
      ResidentialOfferLetter: 1288,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1420,
      ResidentialTenancyContract: 1421,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1418,
      ResidentialTenancyContract: 1419,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
    apiKey: 'FsqMtUmxSJexe10vXF9sC4zhuax3bCZ6GFdwFYpbjKGRCVjvbtsKfXOWfKglVTx7zzzz',
  },
  demo: {
    name: "demo",
    server_address: 'https://apigateway.demo.replica.psi-crm.com',
    ws_address: 'wss://apigateway.demo.replica.psi-crm.com',
    freshdesk_ws_id: 73000000915,
    server_name: 'apigateway.demo.replica.psi-crm.com',
    GetMyFormsReportsTypeReportsBuilder: 3189,
  },
  assets: {
    name: "assets",
    server_address: 'https://apigateway.psiassets-crm.com',
    ws_address: 'wss://apigateway.psiassets-crm.com',
    server_name: 'apigateway.psiassets-crm.com',
    leadxchange_server_address: 'https://apigateway.replica.psi-crm.com',
    ActivityTypesCategoryId: 63385,
    MultiUnitsTemplateId: 1252,
    AI_environment:'Assets',
    hotjarSiteId: 3891241,
    RejectWithCounterProposal: 1827,
    PriceNegotiationApproved: 1825,
    PriceNegotiationRejected: 1826,
    RequestSendingOfferLetter: 1823,
    PriceNegotiation: 1824,
    ContactDocsCategoryIds_EID : 63383,
    ContactDocsCategoryIds_KYC : 63384,
    WhatsAppConsentTemplate : 1422,
    HoldingCompany : 71849,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1283,
      ResidentialOfferLetter: 1281,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1287,
      ResidentialOfferLetter: 1288,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1420,
      ResidentialTenancyContract: 1421,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1418,
      ResidentialTenancyContract: 1419,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
  },
  workflow: {
    name: "workflow",
    server_address: 'https://apigateway.workflow.replica.psi-crm.com',
    ws_address: 'wss://apigateway.workflow.replica.psi-crm.com',
    server_name: 'apigateway.workflow.replica.psi-crm.com',
    ActivityTypesCategoryId: 63385,
    MultiUnitsTemplateId: 1252,
    hotjarSiteId: 3891241,
    ContactDocsCategoryIds_EID : 63383,
    ContactDocsCategoryIds_KYC : 63384,
    WhatsAppConsentTemplate : 1422,
    HoldingCompany : 71849,
    OfferLetterTemplateId: {
      CommercialOfferLetter: 1283,
      ResidentialOfferLetter: 1281,
    },
    TenantOfferLetterTemplateId: {
      CommercialOfferLetter: 1287,
      ResidentialOfferLetter: 1288,
    },
    TenancyContractTemplateId: {
      CommercialTenancyContract: 1420,
      ResidentialTenancyContract: 1421,
    },
    TenantTenancyContractTemplateId: {
      CommercialTenancyContract: 1418,
      ResidentialTenancyContract: 1419,
    },
    InstallmentTypes: {
      DownPayment: 20681,
      HandoverPayment: 70071,
      Installment: 57930,
      PostHandoverInstallment: 70070,
    },
  },
};
const DefaultCommonBaseConfig = {
  organizationsId: '85154615-FBAE-412E-8F39-08D851A0A786',
  applicationId: '523cecec-696a-4c77-9f32-af8227a1b119',
  source: '4D50FC57-C8CB-415D-93FF-AB20A2F23619',
  ApiKey: '0jUt4NHaUOTb3fhfkk35QOOvO4IudrkG4NttIwnbz1wZeVwOHShEEqCeEdpWLopg',
  SendKey: '0jUt4NHaUOTb3fhfkk35QOOvO4IudrkG4NttIwnbz1wZeVwOHShEEqCeEdpWLopg',
  GoogleMapApiKey: 'AIzaSyCzLOjMxvVKsuTeNMxXQllDcJSMnsUPxuY',
  TinyMCE_ApiKey: '0m9n9euh0vwkbvh2rezjo7sca4u6rfavmk2kdkukeeo47zcg',
  timeZone: 'Asia/Dubai',
  freshdesk_ws_id: 73000001170,
  AI_environment:'Dev',
  DisableRightClicking: true,
  MultiUnitsTemplateId: 1626,
  SalesUnitProposalTemplateId: 1062,
  LeasingUnitProposalTemplateId: 1063,
  ContactDocsCategoryIds_EID : 63383,
  ContactDocsCategoryIds_KYC : 63384,
  TaskNotificationTemplateId: 9,
  ContactDocsCategoryIds_Passport : 18099,
  ContactDocsCategoryIds_IDCard : 18098,
  GetMyFormsReportsTypeReportsBuilder: 3179,
  ActivityTypesCategoryId: 62360,
  RejectWithCounterProposal: 2549,
  PriceNegotiationApproved: 2545,
  PriceNegotiationRejected: 2546,
  RequestSendingOfferLetter: 2543,
  PriceNegotiation: 2544,
  version: '3.4.0'
};


export const selectedEnvironment = process.env.REACT_APP_CONFIG || 'development';
export const envActivityCategory = ActivityCategory[selectedEnvironment] ?? ActivityCategory.production;
const environmentConfig = SystemEnvironment[selectedEnvironment];
const config = { ...DefaultCommonBaseConfig, ...environmentConfig, ...envActivityCategory};

export { config };

//         _______________________________________
//        |,---"-----------------------------"---,|
//        ||___    2024 bit....................  ||
//        ||====\ :HHHHHHHHHHHHHHHHHHHHHHHHHHH   ||
//        ||=====):H c> npm i #              H   ||                .--------.       ______
//        ||====/ :H    Propx CRM  Config    H   ||               /   o    /|     /\      \
//        ||"""   :H                         H   ||              /________/o|    / o \  o  \
//        ||CRM   :H                         H   ||              | o      | |   /   o\______\
//        ||      :HHHHHHHHHHHHHHHHHHHHHHHHHHH   ||              |    o   |o/   \o   /o     /
//        ||_____,___________MH____________,_____||              |      o |/     \ o/  o   /
//        |)_____)-----.| / Config |.------(_____(|              '--------'       \/_____o/
//      //"""""""|_____|=----------=|______|"""""""\
//     // _| _| _| _| _| _| _| _| _| _| _| _| _| _| \
//    // ___| _| _| _| _| _| _| _| _| _| _| _|  |  | \
//   |/ ___| _| _| _| _| _| _| _| _| _| _| _| ______| \
//   / __| _| _| _| _| _| _| _| _| _| _| _| _| _| ___| \
//  / _| _| _| _| ________________________| _| _| _| _| \
// |------"--------------------------------------"-------|
// `-----------------------------------------------------'

// ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒░▒░▓
// ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒░
// ░▒██▓▓▓██▓░░░░░░░░░░░▓███████████████▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▓████████████▓░░░░░░░
// ▓█▓░░░░░▒██░░░░░░░░░░░▒████████████████▒░░░░░░░░░░░░░░░░░░░░░░░░░░░▒█████████████▒░░░░░░░░
// ██▒░░░░░░██▒░░░░░░░░░░░░▓███████████████▓░░░░░░░░░░░░░░░░░░░░░░░░░▓████████████▓░░░░░░░░░░
// ██▒░░░░░░██▒░░░░░░░░░░░░░▓████████████████▒░░░░░░░░░░░░░░░░░░░░░░█████████████▒░░░░░░░░░░░
// ██▒░░░░░░▓█▒░░░░░░░░░░░░░░░▓███████████████▓░░░░░░░░░░░░░░░░░░░▓█████████████░░░░░░░░░░░░░
// ██▒░░░░░░░░░░░░░░░░░░░░░░░░░▓████████████████▒░░░░░░░░░░░░░░░░█████████████▓░░░░░░░░░░░░░░
// ████████████████░░░░░░░░░░░░░▒████████████████▓░░░░░░░░░░░░░▒█████████████▒░░░░░░░░░░░░░░░
// ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▓████████████████▒░░░░░░░░░░▓████████████▓░░░░░░░░░░░░░░░░░
// ░░░░▒▓▓▓▓▓▒▒░░░░░░░░░░░░░░░░░░░░▒████████████████▓░░░░░░░▒█████████████▒░░░░░░░░░░░░░░░░░░
// ░▒██▓▒▒░░▒▒▓█▓▒░░░░░░░░░░░░░░░░░░░▓████████████████▒░░░░▓█████████████▒░░░░░░░░░░░░░░░░░░░
// ▒█▓░░░░░░░░░░██▒░░░░░░░░░░░░░░░░░░░▒████████████████▓░░░▓███████████▓░░░░░░░░░░░░░░░░░░░░░
// ██▒░░░░░░░░░░▒██░░░░░░░░░░░░░░░░░░░░░▓████████████████▒░░▒█████████▒░░░░░░░░░░░░░░░░░░░░░░
// ██▒░░░░░░░░░░▒██░░░░░░░░░░░░░░░░░░░░░░▒████████████████▓░░░▓█████▓░░░░░░░░░░░░░░░░░░░░░░░░
// ██▒░░░░░░░░░░▒██░░░░░░░░░░░░░░░░░░░░░░░░█████████████████▒░░▒███▓░░░░░░░░░░░░░░░░░░░░░░░░░
// ▒██▒░░░░░░░░▒██▒░░░░░░░░░░░░░░░░░░░░░░░░░▓████████████████▓░░░▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░
// ░░▓██▓▒▒▒▒▓██▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒█████████████████▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
// ░░░░░▒▒▒▒▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒█████████████████▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
// ░░░░░░░░░░░░░░░▓░░░░░░░░░░░░░░░░░░░░░░░░░▓█████████████████▒░░▒▒░░░░░░░░░░░░░░░░░░░░░░░░░░
// ░▓██▓▓▓▓█▓▒░▒▓█▓░░░░░░░░░░░░░░░░░░░░░░░▒█████████████████▓░░░▓██▓░░░░░░░░░░░░░░░░░░░░░░░░░
// ▓█▓░░░░░░████▒░░░░░░░░░░░░░░░░░░░░░░░░▓█████████████████▒░░▒██████░░░░░░░░░░░░░░░░░░░░░░░░
// ██▒░░░░░░▓█▒░░░░░░░░░░░░░░░░░░░░░░░░▒█████████████████▓░░░▓████████▒░░░░░░░░░░░░░░░░░░░░░░
// ██▒░░░░░░▓█▒░░░░░░░░░░░░░░░░░░░░░░░▓█████████████████▓░░▒███████████▓░░░░░░░░░░░░░░░░░░░░░
// ██▒░░░░░░▓█▒░░░░░░░░░░░░░░░░░░░░░░█████████████████▓░░░░██████████████▒░░░░░░░░░░░░░░░░░░░
// ██▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒█████████████████▒░░░░░░██████████████▓░░░░░░░░░░░░░░░░░░
// ████████████████░░░░░░░░░░░░░░░██████████████████░░░░░░░░░▓██████████████░░░░░░░░░░░░░░░░░
// ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒█████████████████▓░░░░░░░░░░░▒██████████████▓░░░░░░░░░░░░░░░
// ░░▒▓▓██▓▓▒░░░░░░░░░░░░░░░░░░▓████████████████▓░░░░░░░░░░░░░░░▓██████████████░░░░░░░░░░░░░░
// ▒██▒░░░░▓█▓░░░░░░░░░░░░░░░▒█████████████████▓░░░░░░░░░░░░░░░░░▒██████████████▒░░░░░░░░░░░░
// ██▒░░░░░░██▒░░░░░░░░░░░░░▓█████████████████▒░░░░░░░░░░░░░░░░░░░░▓█████████████▓░░░░░░░░░░░
// ██▒░░░░░░██▒░░░░░░░░░░░▒█████████████████▓░░░░░░░░░░░░░░░░░░░░░░░▒██████████████▒░░░░░░░░░
// ██▒░░░░░░██▒░░░░░░░░░░▓█████████████████▒░░░░░░░░░░░░░░░░░░░░░░░░░░▓█████████████▓░░░░░░░░
// ██▒░░░░░░░░░░░░░░░░░▒█████████████████▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒██████████████▒░░░░░░
// ██▓▓▓▓▓▓▓▓▓▓▓▓▓▓░░░▓█████████████████▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░██████████████▓░░░░░

// /$$$$$$$   /$$$$$$  /$$$$$$
// | $$__  $$ /$$__  $$|_  $$_/
// | $$  \ $$| $$  \__/  | $$      | $$   | $$  /$$$$$$   /$$$$$$   /$$$$$$$ /$$  /$$$$$$  /$$$$$$$
// | $$$$$$$/|  $$$$$$   | $$      |  $$ / $$/ /$$__  $$ /$$__  $$ /$$_____/| $$ /$$__  $$| $$__  $$
// | $$____/  \____  $$  | $$       \  $$ $$/ | $$$$$$$$| $$  \__/|  $$$$$$ | $$| $$  \ $$| $$  \ $$
// | $$       /$$  \ $$  | $$        \  $$$/  | $$_____/| $$       \____  $$| $$| $$  | $$| $$  | $$
// | $$      |  $$$$$$/ /$$$$$$       \  $/   |  $$$$$$$| $$       /$$$$$$$/| $$|  $$$$$$/| $$  | $$
// |__/       \______/ |______/        \_/     \_______/|__/      |_______/ |__/ \______/ |__/  |__/
